"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeRenamedMilestone = exports.milestoneNames = void 0;
exports.milestoneNames = [
    'Terraformer',
    'Mayor',
    'Gardener',
    'Planner',
    'Builder',
    'Generalist',
    'Specialist',
    'Ecologist',
    'Tycoon',
    'Legend',
    'Diversifier',
    'Tactician',
    'Polar Explorer',
    'Energizer',
    'Rim Settler',
    'Hoverlord',
    'Networker',
    'One Giant Step',
    'Lunarchitect',
    'Colonizer',
    'Minimalist',
    'Terran',
    'Tropicalist',
    'Economizer',
    'Pioneer',
    'Land Specialist',
    'Martian',
    'T. Collector',
    'Firestarter',
    'Terra Pioneer',
    'Spacefarer',
    'Gambler',
    'V. Electrician',
    'Smith',
    'Tradesman',
    'Irrigator',
    'Capitalist',
    'Agronomist',
    'Engineer',
    'V. Spacefarer',
    'Geologist',
    'Farmer',
    'Tunneler',
    'Risktaker',
    'Purifier',
    'Forester',
    'Fundraiser',
    'Hydrologist',
    'Landshaper',
    'Lobbyist',
    'Philantropist',
    'Planetologist',
    'Producer',
    'Researcher',
    'Sponsor',
    'Thawer',
];
const MILESTONE_RENAMES = new Map([]);
function maybeRenamedMilestone(name) {
    const renamed = MILESTONE_RENAMES.get(name);
    return renamed ?? name;
}
exports.maybeRenamedMilestone = maybeRenamedMilestone;
